import Dialog from '@mui/material/Dialog';
import { useTranslate } from 'react-admin';
import MultiSelectionProvider from '../../../providers/MultiSelectionProvider';
import LinkInputModalInputDialogContent from './LinkInputModalInputDialogContent';
import { HandleSelectClick } from "./types";

interface LinkInputModalProps {
    showDialog: boolean,
    handleSelectClick: HandleSelectClick,
    handleCloseClick: () => void,
    label?: string,
  }
  
  const LinkInputModal = ({ showDialog, handleSelectClick, handleCloseClick, label }: LinkInputModalProps) => {
    const translate = useTranslate();
    return (
      <Dialog
        maxWidth={"xl"}
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate(label ? label : "ra.action.links_manager")}
      >
        <MultiSelectionProvider>
          <LinkInputModalInputDialogContent handleCloseClick={handleCloseClick} handleSelectClick={handleSelectClick} />
        </MultiSelectionProvider>
      </Dialog>
    )
  }
  
  LinkInputModal.defaultProps = {
    label: 'ra.action.links_manager',
  }
  
  export default LinkInputModal;